import { Navigate } from 'react-router-dom';

import ProtectedRoute from '../auth/components/ProtectedRoute';
import { MenuItems } from '../auth/enums/menu-items.enum';
import Layout from '../core/components/Layout';
import { lazyWithRetry } from '../core/utils/lazy-with-retry.util';
import { APP_ROUTE_PATHS } from './appRoutes';

const LeadsysPicturesPage = lazyWithRetry(() => import('../leadsys-pictures/pages/LeadsysPicturesPage'));
const GalleryTagsPage = lazyWithRetry(() => import('../gallery-tags/pages/GalleryTagsPage'));

export default function privateRoutes() {
  return {
    element: <Layout />,
    children: [
      {
        path: APP_ROUTE_PATHS.GALLERY,
        element: (
          <ProtectedRoute menuName={MenuItems.GALLERY}>
            <LeadsysPicturesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: APP_ROUTE_PATHS.GALLERY_TAGS,
        element: (
          <ProtectedRoute menuName={MenuItems.GALLERY_TAGS}>
            <GalleryTagsPage />
          </ProtectedRoute>
        ),
      },
      { path: '*', element: <Navigate to={APP_ROUTE_PATHS.GALLERY} replace /> },
    ],
  };
}
